//**auto-generated don't edit this code**//
export enum AssignmentState {
	None,
	Published,
	NotStarted,
	Completed,
	Draft,
}